<header class="header">
    <h1>Rubric Content Analysis</h1>
</header>
